import React from 'react';
import PropTypes from 'prop-types';

import FieldTextAction from '../fields/fieldTextAction/FieldTextAction';

export default class CheckoutCouponSubform extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {error: false};
  }

  componentDidUpdate(prevProps) {
    const {coupon, input} = this.props;

    if (coupon !== prevProps.coupon) {
      this.setState({error: false});
      input.onChange(coupon || '');
    }

    if (input.value !== prevProps.input.value) {
      this.setState({error: false});
    }
  }

  onAction = (e) => {
    e.stopPropagation();
    e.preventDefault();

    const {input, coupon, applyCoupon, removeCoupon} = this.props;
    const action = coupon ? removeCoupon : applyCoupon;
    const result = action(input.value);

    if (result.then) {
      result.catch(err => {
        const errors = err.response.errors;

        let message = 'Unexpected error';
        if (errors) {
          message = (errors
            && errors.children.promotionCoupon
            && errors.children.promotionCoupon.errors[0]
          ) || errors.message;
        }

        this.setState({error: message});
      });
    }

    return result;
  };

  render() {
    const {coupon, applyCoupon, removeCoupon, ...rest} = this.props;
    const {error} = this.state;

    return (
      <FieldTextAction
        {...rest}
        meta={{
          touched: true,
          error: error
        }}
        disabled={!!coupon}
        actionTitle={coupon ? 'Remove' : 'Apply'}
        onAction={this.onAction}
      />
    )
  }
}



// WEBPACK FOOTER //
// ./components/checkout/CheckoutCouponSubform.js